import { useLocation } from 'react-router-dom';

import { useAuthState } from '@/shared/lib/auth';
import type { RedirectWithoutAccessProps } from '@/shared/lib/react-router';
import { RedirectWithoutAccess } from '@/shared/lib/react-router';

// ----------------------------------------------------------------------

type GuestGuardProps = Pick<RedirectWithoutAccessProps, 'children'>;

// ----------------------------------------------------------------------

export const GuestGuard = (props: GuestGuardProps) => {
  const { children } = props;

  const { isAuthenticated } = useAuthState();
  const { state } = useLocation();

  const from = (state as { from: string })?.from ?? '/';

  return (
    <RedirectWithoutAccess hasAccess={!isAuthenticated} to={from}>
      {children}
    </RedirectWithoutAccess>
  );
};
